module.exports = __webpack_public_path__ + "static/media/Tutorial-LodgeComplaint.bf2d37d2.pdf";